import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { CASE_STATUS_STYLE } from "../lib/collab";
import { Loader2, Users, ArrowRight } from "lucide-react";

export default function CollabCases() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/collab/cases")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <div className="flex items-center gap-3">
        <Users size={22} className="text-[var(--pa-gold)]" />
        <div>
          <div className="kicker">Collaboration</div>
          <h1
            data-testid="collab-list-title"
            className="font-serif text-3xl text-[var(--pa-text)]"
          >
            Interdisciplinary Cases
          </h1>
        </div>
      </div>
      <p className="mt-3 text-xs text-[var(--pa-text-muted)] max-w-2xl">
        Cases where you've requested input from periodontists, endodontists, oral surgeons,
        orthodontists, or other specialists. Each case shows which specialists have submitted
        and which are still pending.
      </p>

      <div className="mt-8" data-testid="collab-list">
        {loading ? (
          <div className="flex items-center gap-2 text-sm text-[var(--pa-text-muted)]">
            <Loader2 size={14} className="animate-spin text-[var(--pa-gold)]" /> Loading…
          </div>
        ) : items.length === 0 ? (
          <div className="p-10 text-center text-sm text-[var(--pa-text-muted)] border border-dashed border-[var(--pa-border)] rounded-md">
            No interdisciplinary cases yet. Open any Complete Case Analysis and click{" "}
            <span className="text-[var(--pa-gold)]">Request Specialist Input</span> to start
            collaborating.
          </div>
        ) : (
          <div className="space-y-3">
            {items.map((c) => {
              const status = CASE_STATUS_STYLE[c.status] || CASE_STATUS_STYLE.pending;
              const submitted = c.invites.filter((i) => i.status === "submitted").length;
              const total = c.invites.length;
              return (
                <Link
                  key={c.id}
                  to={`/collab-cases/${c.id}`}
                  data-testid={`collab-row-${c.id}`}
                  className="flex items-center justify-between p-4 bg-[var(--pa-surface)] border border-[var(--pa-border)] rounded-md hover:border-[var(--pa-gold)]/60 transition group"
                >
                  <div>
                    <div className={`text-xs ${status.color}`}>{status.label}</div>
                    <div className="mt-1 text-sm text-[var(--pa-text)]">
                      {submitted}/{total} specialist
                      {total === 1 ? "" : "s"} submitted
                      {c.specialist_review_recommended && (
                        <span className="ml-2 text-[10px] uppercase tracking-wider text-[var(--pa-gold)]">
                          · 3+ — Specialist review recommended
                        </span>
                      )}
                    </div>
                    <div className="mt-1 text-[10px] text-[var(--pa-text-dim)]">
                      Created {new Date(c.created_at).toLocaleString()}
                    </div>
                  </div>
                  <ArrowRight
                    size={16}
                    className="text-[var(--pa-text-dim)] group-hover:text-[var(--pa-gold)]"
                  />
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </Layout>
  );
}
